import { createMuiTheme } from '@material-ui/core/styles';

// Overrides values of the material-ui theme
export const InventoryTheme = createMuiTheme({
    typography: {
        useNextVariants: true,
        h1: {
            fontSize: "3.0rem",
            fontWeight: 500,
        },
    }
});